import BrandsSectionPage from "../views/BrandsSection/BrandsSection";
import NewBrandStationPage from "../views/NewBrandStation/newBrandStation";
import NewBrandSalesPage from "../views/NewBrandSales/newBrandSales";

import DashboardIcon from "@material-ui/icons/Dashboard";
import LanguageIcon from "@material-ui/icons/Language";

export const marketingRoutes = [
  {
    collapse: true,
    name: "Marketing",
    icon: LanguageIcon,
    state: "marketingCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "MARKETING",
    views: [
      {
        path: "/marcas",
        name: "Marcas",
        mini: "Mrc",
        component: BrandsSectionPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "MARKETING",
      },
      {
        path: "/nuevo_marca_planta",
        name: "Nueva Marca por planta",
        icon: DashboardIcon,
        component: NewBrandStationPage,
        layout: "/admin",
        inSidebar: false,
      },
      {
        path: "/editar_marca_planta/:isEdit/:id",
        name: "Editar marca por planta",
        icon: DashboardIcon,
        component: NewBrandStationPage,
        layout: "/admin",
        sublayout: "/editar_marca",
        isEdit: true,
        inSidebar: false,
      },
      {
        path: "/nuevo_marca_venta",
        name: "Nueva marca ventas",
        icon: DashboardIcon,
        component: NewBrandSalesPage,
        layout: "/admin",
        inSidebar: false,
      },
      {
        path: "/editar_marca_venta/:isEdit/:id",
        name: "Editar marca ventas",
        icon: DashboardIcon,
        component: NewBrandSalesPage,
        layout: "/admin",
        sublayout: "/editar_marca",
        isEdit: true,
        inSidebar: false,
      },
    ],
  },
]